// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().name("player_id"),
  playerName: __t.string().name("player_name"),
  authenticated: __t.bool(),
  userId: __t.option(__t.string()).name("user_id"),
  username: __t.option(__t.string()),
  tier: __t.string(),
});
